import {Vector2} from "@utility/vector2";
import {ILocation} from "@game/game";

interface IMapSize {
    campDuration: number
    mapRegions: number[]
    regionTiles: number[]
}

export class MapSize {
    private readonly _mapRegions: Vector2;
    private readonly _regionTiles: Vector2;

    constructor(private props: IMapSize) {
        this._mapRegions = new Vector2(props.mapRegions);
        this._regionTiles = new Vector2(props.regionTiles);
    }

    get campDuration() {
        return this.props.campDuration;
    }
    
    get mapTiles() {
        return this._mapRegions.multiply(this._regionTiles);
    }

    get mapRegions() {
        return this._mapRegions;
    }

    get regionTiles() {
        return this._regionTiles;
    }

    getLocationOffset(location: ILocation, offset: Vector2): ILocation {
        const position = this.getTilePosition(location).plus(offset);

        return this.getTileLocation(position);
    }

    getTileId(position: Vector2) {
        return this.regionTiles.y * position.x + position.y;
    }

    getTileLocation(position: Vector2): ILocation{
        return {
            regionId: this.getTileRegionId(position),
            tileId: this.getRegionTileId(position)
        }
    }

    getTileRegion(tile: Vector2) {
        return tile.divide(this.regionTiles).floor();
    }

    getTileRegionId(tile: Vector2) {
        return this.getRegionId(this.getTileRegion(tile));
    }

    getTileRegionOffset(tile: Vector2 | number) {
        if (typeof(tile) === "number") {
            return new Vector2(Math.floor(tile / this.regionTiles.x), tile % this.regionTiles.x);
        } else {
            return tile.mod(this.regionTiles);
        }
    }

    getRegionId(region: Vector2) {
        return region.x * this.mapRegions.x + region.y;
    }

    getRegionTileId(tile: Vector2) {
        return this.getTileId(this.getTileRegionOffset(tile));
    }

    getRegionPosition(regionId: number) {
        return new Vector2(Math.floor(regionId / this.mapRegions.x), regionId % this.mapRegions.x);
    }

    getTilePosition(playerLocation: ILocation) {
        const region = this.getRegionPosition(playerLocation.regionId);
        const tile = this.getTileRegionOffset(playerLocation.tileId);

        return region.multiply(this.regionTiles).plus(tile);
    }
}
